// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"f3d7c1f0","464":"a5bcccfe","823":"0dc659a3","873":"0dc659a3"}[chunkId] + ".chunk.css";
};